import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"

export const TAG_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "label", width: 200 },
  { key: "icon", width: 70, align: "center" },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const TAG_SORTABLE_FIELDS = ["label", "icon", "lastUpdatedAt"] as const

/**
 * Default tag options used to seed the Firestore tags collection.
 * Once seeded, the source of truth is the DB — these are only for initial population.
 */
// export const DEFAULT_TAG_OPTIONS = [
//   { value: "takesTheBus", label: "Takes the Bus", icon: "🚌" },
//   { value: "walksHome", label: "Walks Home", icon: "🚶" },
//   { value: "needsExtraCare", label: "Needs Extra Care", icon: "🚩" },
//   { value: "parentsPickUp", label: "Parent Pick Up", icon: "🚗" },
//   { value: "alwaysLate", label: "Always Late", icon: "⏰" },
//   { value: "needsToPay", label: "Needs to Pay", icon: "💸" },
//   { value: "afterSchoolProgram", label: "After School Program", icon: "🏫" },
// ]
